import { render, staticRenderFns } from "./DoctorDebtStatement.vue?vue&type=template&id=41a47388&scoped=true"
import script from "./DoctorDebtStatement.vue?vue&type=script&lang=js"
export * from "./DoctorDebtStatement.vue?vue&type=script&lang=js"
import style0 from "./DoctorDebtStatement.vue?vue&type=style&index=0&id=41a47388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a47388",
  null
  
)

export default component.exports